import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid, Loader2, Tag } from 'lucide-react';
import { useShopCategories } from '../../hooks/useShopCategories';

/**
 * The gift shop's left category menu.
 *
 * Rendered only when Developer Settings -> Feature Flags -> **Left Menu** is on: that switch now
 * really controls the left menu on the shop home page, the category pages and the product pages.
 * Categories come from the catalogue, so adding one in the admin adds it here.
 */
const ShopCategoryMenu = ({ activeSlug = '' }) => {
  const { categories, loading } = useShopCategories();

  return (
    <nav className="rounded-xl border border-slate-200 bg-white p-4" data-testid="shop-left-menu" aria-label="Shop categories">
      <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
        <LayoutGrid className="h-3.5 w-3.5" /> Shop by category
      </p>

      {loading ? (
        <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-blue-700" /></div>
      ) : (
        <ul className="space-y-1">
          <li>
            <Link
              to="/shop/products"
              className={`block rounded px-3 py-2 text-sm font-semibold transition-colors ${
                activeSlug ? 'text-slate-700 hover:bg-blue-50 hover:text-blue-800' : 'bg-blue-800 text-white'
              }`}
              data-testid="shop-left-menu-all"
            >
              All Products
            </Link>
          </li>
          {categories.map((category) => (
            <li key={category.id}>
              <Link
                to={`/shop/category/${category.slug}`}
                className={`flex items-center gap-2 rounded px-3 py-2 text-sm transition-colors ${
                  activeSlug === category.slug
                    ? 'bg-blue-800 font-semibold text-white'
                    : 'text-slate-700 hover:bg-blue-50 hover:text-blue-800'
                }`}
                data-testid={`shop-left-menu-${category.slug}`}
              >
                <Tag className="h-3.5 w-3.5 opacity-60" /> {category.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default ShopCategoryMenu;
